import EntityService from '@/services/EntityService'
import FirebaseService from '@/services/FirebaseService'
import { doc, getDoc } from 'firebase/firestore'

export default class SettingService extends EntityService<any> {
  constructor() {
    super({ collectionName: 'settings' })
  }

  /**
   * Find a record by id
   * 
   * @param id
   * @returns Promise<T>
   */
  public async find(id: string) {
    const db = await FirebaseService.firestore()
    const docRef = doc(db, this.collectionName, id)
    const record = (await getDoc(docRef)).data()

    return record as any
  }
}